<template>
  <div>
    <h1 class="title">Roof Model Management</h1>
    <div class="box has-background-light">
      <div class="form">
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">Roof Model Name</label>
              <input class="input" type="text" v-model="roofModelName">
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Roof Model Description</label>
              <input class="input" type="text" v-model="roofModelDesc">
            </div>
          </div>
        </div>
        <div class="field">
          <button class="button" :disabled="loading" :class="{ 'is-loading': loading }" @click="addRoofModel">Add Roof Model</button>
        </div>
      </div>
    </div>

    <viewRoofModel :models="roofModels" />
  </div>
</template>

<script>
import errorHandler from '@/errorHandler';
import viewRoofModel from '@/components/settings/viewRoofModels.vue';

export default {
  components: {
    viewRoofModel,
  },

  data() {
    return {
      loading: false,
      roofModelName: '',
      roofModelDesc: '',
      roofModels: [],
    };
  },

  mounted() {
    this.fetchRoofModels();
  },

  methods: {
    addRoofModel() {
      this.loading = true;

      fetch('/api/roof', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ model: this.roofModelName, description: this.roofModelDesc }),
      }).then(res => res.json())
        .catch(error => errorHandler(error))
        .then((response) => {
          // Reset form
          this.loading = false;
          this.roofModelName = '';
          this.roofModelDesc = '';
          // Notify User
          this.$awn.success('Roof Model Added');
          // Add the new roof model to the list
          this.roofModels.push(response);
        });
    },

    fetchRoofModels() {
      fetch('/api/roof/list', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(res => res.json())
        .catch(error => errorHandler(error))
        .then((response) => {
          this.roofModels = response.roofs;
        });
    },
  },
};
</script>
